import React from 'react';
// @ts-ignore
import SchemaAttributeName from 'components/SchemaAttributeName';

interface Props {
    schemaAttributeId: number;
    documentSetId: number; // eslint-disable-line
}

export default function JobAttributeLabel(props: Props): React.ReactElement {
    const { schemaAttributeId } = props;
    return (
        <React.Fragment>
            <SchemaAttributeName schemaAttributeId={schemaAttributeId} />
        </React.Fragment>
    );
}
